import React from 'react';
import Navbar from './Navbar';
import SubNavbar from './SubNavbar';
const AdminNav = () => {
  return (
    <div className="admin-header">
      <Navbar/>
      <SubNavbar/>
    </div>
  )
}

export default AdminNav;